import { render, staticRenderFns } from "./MinecraftFormattingMenu.vue?vue&type=template&id=0c0a12b1"
import script from "./MinecraftFormattingMenu.vue?vue&type=script&lang=js"
export * from "./MinecraftFormattingMenu.vue?vue&type=script&lang=js"
import style0 from "./MinecraftFormattingMenu.vue?vue&type=style&index=0&id=0c0a12b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports